import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';
import { ServicesContext, defaultColumnPresets } from '~/services';

export interface SaveNewColumnPresetProps {
    setSelectedPreset: (preset: string) => void;
    orderedColumns: string[];
    onDismiss: () => void;
}
export function SaveNewColumnPreset({
    setSelectedPreset,
    orderedColumns,
    onDismiss,
}: SaveNewColumnPresetProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [adding, setAdding] = React.useState(false);
    const [presetName, setPresetName] = React.useState('');
    const [duplicateName, setDuplicateName] = React.useState(false);

    async function save() {
        if (defaultColumnPresets.map((x) => x.label).includes(presetName)) {
            setDuplicateName(true);
            return;
        }
        try {
            setAdding(true);
            const newPreset = {
                label: presetName,
                columns: orderedColumns,
            };
            await servicesContext.user.addSavedSearchData('column_presets', newPreset, {
                handledErrors: true,
            });
            setAdding(false);
            setSelectedPreset(presetName);
            onDismiss();
        } catch (e) {
            setDuplicateName(true);
            setAdding(false);
        }
    }

    return (
        <div className="row text-center">
            <Form id="save-new-column" className="col" onSubmit={save} values={{ presetName }}>
                <FormGroup htmlFor="presetName" submitted={false} validation={null}>
                    <input
                        placeholder="Enter Preset Name"
                        aria-label="Preset name input"
                        type="text"
                        className="form-control d-inline"
                        id="presetName"
                        required
                        maxLength={50}
                        value={presetName}
                        onChange={(e) => setPresetName(e.target.value)}
                    />
                    <button
                        className="ms-2 me-2 btn btn-secondary"
                        type="button"
                        onClick={onDismiss}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        form="save-new-column"
                        className="btn btn-primary"
                        disabled={adding || !presetName}
                    >
                        {adding && (
                            <Spinner
                                animation="border"
                                variant="light"
                                size="sm"
                                role="status"
                                className="me-1"
                            />
                        )}
                        Save
                    </button>
                    <ValidationMessage
                        showBeforeSubmit
                        type="external"
                        rule={duplicateName}
                        className="col-12"
                    >
                        This preset name is already in use. Please select a unique name.
                    </ValidationMessage>
                </FormGroup>
            </Form>
        </div>
    );
}
